import get from 'lodash/get';

export const DISPLAY_CONVERSION_MODAL = 'displayConversionModal';
export const DISPLAY_MOTIVATIONAL_PROMPT = 'displayMotivationalPrompt';
export const DISPLAY_NEW_SPEECH_RATE = 'displayNewSpeechRate';

export const isFeatureEnabled = (configuration: object | undefined, feature: string) => {
    return !!get(configuration as object | undefined, feature, false);
};
